import { useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { BigButton } from "@/components/Field";
import { TextArea } from "@/components/Bits";
import { api, errMsg } from "@/lib/api";

const LABELS = ["", "Ruim", "Regular", "Bom", "Muito bom", "Excelente"];

export const Stars = ({ value, onChange, size = "h-10 w-10" }) => (
  <div className="flex justify-center gap-1" data-testid="rating-stars">
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" disabled={!onChange} onClick={() => onChange?.(n)} aria-label={`${n} estrela(s)`} data-testid={`rating-star-${n}`}
        className={`${onChange ? "p-1 active:scale-90 transition-transform" : "cursor-default"}`}>
        <Star className={`${size} ${n <= value ? "fill-[#E0A100] text-[#E0A100]" : "text-[#D9D3C7]"}`} />
      </button>
    ))}
  </div>
);

export const RatingDialog = ({ open, onOpenChange, os, onSaved }) => {
  const [nota, setNota] = useState(0);
  const [comentario, setComentario] = useState("");
  const save = async () => {
    try {
      await api.post(`/ordens/${os.os_id}/avaliacao`, { nota, comentario });
      toast.success("Obrigado pela avaliação!");
      onOpenChange(false);
      onSaved();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-3xl" data-testid="rating-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl text-center">Como foi o atendimento?</DialogTitle></DialogHeader>
        <p className="text-center text-sm text-[#5C6B66] -mt-2">Avalie o serviço da {os.numero}</p>
        <Stars value={nota} onChange={setNota} size="h-12 w-12" />
        <p className="text-center font-semibold h-6 text-[#1E4D2B]" data-testid="rating-label">{LABELS[nota]}</p>
        <TextArea label="Comentário (opcional)" id="rt-com" value={comentario} onChange={(e) => setComentario(e.target.value)} data-testid="rating-comment" />
        <BigButton onClick={save} disabled={!nota} data-testid="rating-submit">Enviar avaliação</BigButton>
        <button onClick={() => onOpenChange(false)} className="h-12 text-[#5C6B66] font-semibold" data-testid="rating-skip">Agora não</button>
      </DialogContent>
    </Dialog>
  );
};

export const RatingView = ({ av }) => (
  <div className="rounded-2xl bg-[#FFF8E6] border border-[#F2DFA8] p-4 mt-4 text-center" data-testid="rating-view">
    <p className="text-[11px] font-bold uppercase tracking-wider text-[#5C6B66]">Avaliação do serviço</p>
    <div className="my-2"><Stars value={av.nota} size="h-7 w-7" /></div>
    <p className="font-semibold">{av.nota}/5 · {LABELS[av.nota]}</p>
    {av.comentario && <p className="mt-1 italic text-[#5C6B66]">"{av.comentario}"</p>}
    <p className="text-xs text-[#5C6B66] mt-1">{av.nome}</p>
  </div>
);
